import { gql } from '@apollo/client/core'
import {
  SERVER_ERROR,
  UNAUTHENTICATED_ERROR,
  UNAUTHORIZED_ERROR
} from '@base/api/fragments/errors'

import { COURSE_FRAGMENT } from '@base/api/fragments/course'

export const COURSES_QUERY = gql`
  ${UNAUTHENTICATED_ERROR}
  ${UNAUTHORIZED_ERROR}
  ${SERVER_ERROR}
  ${COURSE_FRAGMENT}

  query listCourses($slug: String, $startDate: DateTime, $endDate: DateTime) {
    listCourses(filter: { clubSlug: $slug }, sort: [], limit: 10, offset: 0) {
      ... on ListCoursesOutput {
        courses {
          ...Course
          teeTimes(
            filter: { startTimestamp: $startDate, endTimestamp: $endDate }
            sort: []
          ) {
            ... on ListTeeTimesOutput {
              teeTimes {
                id
                time
                availability
              }
            }
          }
        }
        count
      }
      ... on ListCoursesErrorOutput {
        errors {
          courseName
          numHoles
          startDate
          endDate
          availability
          addressGeom
          sort
          limit
          offset
        }
      }
      ...UnauthorizedError
      ...UnauthenticatedError
      ...ServerError
    }
  }
`
